function Linkedin() {
    return (
        <svg
            id="eJgYiDb39dZ1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 36 36"
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
            className="size-9"
        >
            <rect
                width="35.0842"
                height="35.0842"
                rx="17.5421"
                ry="17.5421"
                transform="translate(.457895 0.457895)"
                fill="#fff"
                stroke="#1f4464"
                strokeWidth="0.915789"
            />
            <path
                d="M9,10.7416c0-.6371.22298-1.16268.66892-1.57676s1.02568-.62114,1.73918-.62114c.7008,0,1.2678.20385,1.701.61158.4459.42047.6689.96832.6689,1.64362c0,.6116-.2166,1.1212-.6498,1.529-.446.4204-1.0321.6307-1.7583.6307h-.0191c-.7008,0-1.2678-.2103-1.70099-.6307s-.64981-.9493-.64981-1.5863Zm.24846,16.7229v-12.7667h4.24284v12.7667h-4.24284Zm6.59364,0h4.2428v-7.1287c0-.446.051-.79.1529-1.0321.1784-.4332.4492-.7995.8123-1.0989s.8186-.4491,1.3665-.4491c1.427,0,2.1405.9619,2.1405,2.8859v6.8229h4.2429v-7.3198c0-1.8858-.4459-3.316-1.3378-4.2907s-2.0705-1.462-3.5358-1.462c-1.6436,0-2.9241.7071-3.8415,2.1214v.0382h-.0191l.0191-.0382v-1.8156h-4.2428c.0255.4077.0382,1.6754.0382,3.8032s-.0127,5.1157-.0382,8.9635Z"
                fill="#1f4464"
            />
        </svg>
    );
}

export default Linkedin;
